import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { trackPageView } from '@/lib/analytics/factories/pageFactory';
import { gtagConfig } from '@/lib/analytics/utils/gtag';

export function usePageTracking() {
  const location = useLocation();

  useEffect(() => {
    const path = location.pathname + location.search;
    gtagConfig(path, document.title);
    trackPageView(path, document.title);
  }, [location]);
}
